export default [
    // {
    //     path: '/promo/renew',
    //     name: 'mha.promo.renew',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.renew" */ '@/modules/promos/renew/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.renew" */ '@/views/public/footer/index.vue')
    //     },
    //     meta: {
    //         headerRegistrationButtonText: 'RENEW NOW - RISK FREE',
    //         // promoType: 'annual',
    //         // promoId: '20',
    //         // membershipTypeId: 'ap67D',
    //         // promoEnd: '2020-04-26T17:00:00-05:00'
    //     }
    // },
    // {
    //     path: '/cce/promo',
    //     name: 'mha.promo.cce',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/cce/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //         meta: {
    //             linksToHide: ['join'],
    //             headerLogos: [
    //                 {
    //                     href: 'https://www.cce-global.org/',
    //                     imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/affiliates/cce_logo.svg',
    //                     imgAlt: 'CCE Logo',
    //                     style: 'max-width:200px;margin-top:.8rem;margin-bottom: .5rem;'
    //                 }
    //             ]
    //         }
    // },

    {
        path: '/promo/join',
        name: 'mha.promo.join',
        components: {
            default: () => import(/* webpackChunkName: "promo.join" */ '@/modules/promos/join/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.join" */ '@/modules/promos/components3/footer.vue')
        },
        props: true,
            meta: {
                linksToHide: ['join'],
                headerRegistrationButtonText: 'JOIN NOW',
                showArrow: true,
                isLandingPage: true,
                promoId: "88",
                isRenew: false
            }
    },
    {
        path: '/promo/renew',
        name: 'mha.promo.renew',
        components: {
            default: () => import(/* webpackChunkName: "promo.join" */ '@/modules/promos/renew/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo.join" */ '@/modules/promos/components3/footer.vue')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerRegistrationButtonText: 'RENEW NOW',
            mobileMenuButtonText: 'Renew Now',
            promoId: "181",
            showArrow: true,
            isLandingPage: true,
            isRenew: true
        },
    },
    {
        path: '/trial',
        name: 'mha.promo.trial',
        components: {
            default: () => import(/* webpackChunkName: "promo" */ '@/modules/promos/trial/views/Experiment.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/modules/promos/components3/footer.vue')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerRegistrationButtonText: 'START 30-DAY TRIAL',
            promoId: '180',
        },
    },
    // {
    //     path: '/vca/trial',
    //     name: 'mha.promo.vca.trial',
    //     components: {
    //         default: () => import('@/modules/promos/trials/vca/Index.vue'),
    //         footer: () => import('@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'START 30-DAY TRIAL',
    //         headerLogos: [
    //             {
    //                 href: 'https://www.vcacounselors.org/',
    //                 imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/promo/vca/vca_logo_1.png',
    //                 imgAlt: 'VCA Logo',
    //                 style: 'max-width:200px;'
    //             }
    //         ]
    //     },
    // },
    // {
    //     path: '/renew/annual',
    //     name: 'mha.promo.renew.annual',
    //     components: {
    //        default: () => import(/* webpackChunkName: "promo.renew" */ '@/modules/promos/renew/views/Index.vue'),
    //         header: () => import(/* webpackChunkName: "promo.renew" */ '@/modules/promos/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.renew" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'RENEW NOW',
    //         promoType: 'annual',
    //         promoEnd: '2020-04-26T17:00:00-05:00'
    //     }
    // },
    // {
    //     path: '/renew/monthly',
    //     name: 'mha.promo.renew.monthly',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.renew" */ '@/modules/promos/renew/views/Index.vue'),
    //         header: () => import(/* webpackChunkName: "promo.renew" */ '@/modules/promos/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.renew" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //    meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'RENEW NOW',
    //         promoType: 'monthly',
    //         promoEnd: '2020-04-26T17:00:00-05:00'
    //     }
    // },
    // {
    //     path: '/renew/flexible',
    //     name: 'mha.promo.renew.flexible',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.renew" */ '@/modules/promos/renew/views/Index.vue'),
    //         header: () => import(/* webpackChunkName: "promo.renew" */ '@/modules/promos/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.renew" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'RENEW NOW',
    //         promoType: 'flexible',
    //         promoEnd: '2020-04-26T17:00:00-04:00'
    //     }
    // },
    {
        path: '/cce/trial',
        name: 'mha.promo.cce.trial',
        components: {
            default: () => import(/* webpackChunkName: "promo" */ '@/modules/promos/trials/cce/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/modules/promos/components3/footer.vue')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerRegistrationButtonText: 'START 30-DAY TRIAL',
            promoType: 'monthly',
            mobileMenuButtonText: 'Join Now',
            headerLogos: [
                {
                    href: 'https://www.cce-global.org/',
                    // The 681px-wide logo /cce uses, scaled down. cce.png is
                    // only 192px wide and blurs on high-density screens.
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/affiliates/cce.jpg',
                    imgAlt: 'CCE Logo',
                    style: 'max-width:185px;'
                }
            ],
            promoId: 91,
        },
    },
    {
        path: '/ccpa/trial',
        name: 'mha.promo.ccpa.trial',
        components: {
            default: () => import(/* webpackChunkName: "promo" */ '@/modules/promos/trials/ccpa/views/Index.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/modules/promos/components3/footer.vue')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerRegistrationButtonText: 'START 30-DAY TRIAL',
            promoType: 'monthly',
            mobileMenuButtonText: 'Join Now',
            headerLogos: [
                {
                    href: 'https://www.ccpa-accp.ca/',
                    imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/ccpa/ccpa-logo.png',
                    imgAlt: 'CCPA Logo',
                    // 185px, as /ccpa draws it. max-width rather than /ccpa's
                    // width, so the trial header's mobile sizes still apply.
                    style: 'max-width:185px;'
                }
            ],
            promoId: 92,
        },
    },
    {
        path: '/casw/trial',
        name: 'mha.promo.casw.trial',
        components: {
            default: () => import(/* webpackChunkName: "promo" */ '@/modules/promos/trials/casw/Index.vue'),
            footer: () => import(/* webpackChunkName: "promo" */ '@/views/public/footer/index.vue')
        },
        props: true,
        meta: {
            linksToHide: ['join'],
            headerRegistrationButtonText: 'START 30-DAY TRIAL',
            promoType: 'monthly',
            promoId: "44",
        },
    },
    // {
    //     path: '/ccpa/promo',
    //     name: 'mha.promo.ccpa',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.ccpa" */ '@/modules/promos/ccpa/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.ccpa" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'JOIN NOW - RISK FREE',
    //         headerLogos: [
    //             {
    //                 href: 'https://www.ccpa-accp.ca/',
    //                 imgSrc: 'https://d9hv9sikl36u8.cloudfront.net/images/ccpa/ccpa-logo.png',
    //                 imgAlt: 'CCPA Logo',
    //                 style: 'max-width:228px;height:auto;'
    //             }
    //         ]
    //     }
    // },
    // {
    //     path: '/special',
    //     name: 'mha.promo.special.join',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/special/views/Index.vue'),
    //         header: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'JOIN NOW',
    //         showArrow: true,
    //         isLandingPage: true
    //     },
    // },
    // {
    //     path: '/special/renew',
    //     name: 'mha.promo.special.renew',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/special/views/Index.vue'),
    //         header: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'RENEW NOW',
    //         showArrow: true,
    //         isLandingPage: true
    //     },
    // }
    // {
    //     path: '/promo/join',
    //     name: 'mha.promo.eofy.join',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/eofy/eofy23/views/Index.vue'),
    //         header: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'JOIN NOW',
    //         showArrow: true,
    //         isLandingPage: true,
    //         promoId: "7xm0z",
    //         isRenew: false
    //     },
    // },
    // {
    //     path: '/promo/renew',
    //     name: 'mha.promo.eofy.renew',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/eofy/eofy23/views/Index.vue'),
    //         header: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/components/TheHeader.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.mha" */ '@/views/public/footer/index.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'RENEW NOW',
    //         showArrow: true,
    //         isLandingPage: true,
    //         promoId: "GNaR5",
    //         isRenew: true
    //     },
    // },
    // {
    //     path: '/promo/renew',
    //     name: 'mha.promo.renew',
    //     components: {
    //         default: () => import(/* webpackChunkName: "promo.mha" */ '@/modules/promos/renew/views/Index.vue'),
    //         footer: () => import(/* webpackChunkName: "promo.join" */ '@/modules/promos/components3/footer.vue')
    //     },
    //     props: true,
    //     meta: {
    //         linksToHide: ['join'],
    //         headerRegistrationButtonText: 'RENEW NOW',
    //         promoId: "39", // ezMZx
    //         showArrow: true,
    //         isLandingPage: true,
    //         isRenew: true
    //     },
    // },
]